import axios from 'axios';

export function getInterests() {
    return axios.get(
        `${process.env.REACT_APP_REPO}/v1/repo_aden/miscs/intereses`
    );
}
